<template>
  <div class="modal fade" id="campaingsModal" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="campaingsModalModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header ">
          <h5 class="modal-title" id="campaingsModal">Lista de las campañas</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <table class="table" style="display: none ;">
            <thead>
              <tr>
                <th scope="col">Nombre</th>
                <th scope="col">Código</th>
                <th scope="col">Abstract</th>
                <th scope="col">Descripción</th>
                <th scope="col">Edit</th>
              </tr>
            </thead>
            <tbody>
              <!-- <div v-for="campaign in campaignsList" :key="campaign.id">
                <tr>
                  <td  scope="row"> {{ campaign.name }} </td>
                  <td  scope="row"> {{ campaign.code }}</td>
                  <td  scope="row"> {{ campaign.abstract }}</td>
                  <td  scope="row"> {{ campaign.description }}</td>
                  <td  scope="row"> </td>
                </tr>
              </div> -->
              <tr v-for="campaign in campaignsList" :key="campaign.id" >
                <td  scope="row"> {{ campaign.name }} </td>
                <td  scope="row"> {{ campaign.code }}</td>
                <td  scope="row"> {{ campaign.abstract }}</td>
                <td  scope="row"> {{ campaign.description }}</td>
                <td  scope="row"> </td>
                <table class="table">
                    <tr v-for="campain_data in campaign.campain_data" :key="campain_data.id" >
                        <td  scope="row"> {{ campain_data.name }} </td>
                        <td  scope="row"> {{ campain_data.campaign_date }}</td>
                        <td  scope="row"> {{ campain_data.description }}</td>
                        <td  scope="row"> {{ campain_data.comments }}</td>
                    </tr>
                </table>
              </tr>
            </tbody>
          </table>
          <div class="container-fluid">
            <div class="row col-12 ml-2 mr-2 mt-2 mb-0 font-weight-bold" >
              <div class="col" >Nombre </div>
              <div class="col" >Código</div>
              <div class="col" >Abstract</div>
              <div class="col" >Descripción</div>
              <div class="col" >Objetivos</div>
              <div class="col" >Localización</div>
              <div class="col" ></div>
            </div>
            <div v-for="campaign in campaignsList" :key="campaign.id" class="row col-12 ml-2 mr-2 mt-2 mb-1 pt-3 border-top ">
              <div class="col" >
                <input type="text" class="form-control border-0 " v-model="campaign.name">
              </div>
              <div class="col" >
                <input type="text" class="form-control border-0 " v-model="campaign.code">
              </div>
              <div class="col" >
                <input type="text" class="form-control border-0 " v-model="campaign.abstract">
              </div>
              <div class="col" >
                <input type="text" class="form-control border-0 " v-model="campaign.description">
              </div>
              <div class="col" >
                <input type="text" class="form-control border-0 " v-model="campaign.Objetivos">
              </div>
              <div class="col" >
                <input type="text" class="form-control border-0 " v-model="campaign.Localización">
              </div>
              <div class="col" >
                <button class="btn btn-secondary" @click="updateCampaign(campaign)">Update</button>
                <button class="btn btn-danger" @click="deleteCampaign(campaign.pk)">Delete</button>
              </div>
              <div class="row col-12 font-weight-bold mt-2 pt-3 mb-2 ml-2 border-top" >
                  <div class="col" >Nombre del set </div>
                  <div class="col" >Fecha de medición</div>
                  <div class="col" >Descripción</div>
                  <div class="col" >Comentarios</div>
                  <div class="col" ></div>
              </div>
              <div v-for="campain_data in campaign.campain_data" :key="campain_data.id" class="row col-12 mt-1 pt-1 ml-2" >
                  <div class="col" >
                    <input type="text" class="form-control border-0 " v-model=" campain_data.name ">
                  </div>
                  <div class="col" >
                    <input type="date" class="form-control border-0 " v-model=" campain_data.campaign_date ">
                  </div>
                  <div class="col" >
                    <input type="text" class="form-control border-0 " v-model=" campain_data.description ">
                  </div>
                  <div class="col" >
                    <input type="text" class="form-control border-0 " v-model=" campain_data.comments ">
                  </div>
                  <div class="col" >
                    <button class="btn btn-secondary" @click="updateCampaignData(campain_data)">Update</button>
                    <button class="btn btn-danger" @click="deleteCampaignData(campaign.pk)">Delete</button>
                  </div>
              </div>

              <!-- <div class="row">
                <div class="col-md-6">
                  Level 2: .col-md-6
                </div>
                <div class="col-md-6">
                  Level 2: .col-md-6
                </div>
              </div> -->
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getData,putData,} from './../services/api'
export default {
  name: "configCampaigns",
  data() {
    return {
      campaignsList: []
    };
  },
  computed: {

  },
  mounted () {
    this.getCampaignsList()
  },
  methods: {
    getCampaignsList: function () {
      var url = 'campaign/campaigns-organization/'
      getData(url).then(res=> {
        this.campaignsList = res.data.campaigns
      })
    },
    updateCampaign: function (campaign) {
      var url = 'campaign/campaigns/'
      putData(url,campaign.pk,campaign).then(res=> {
          console.log(res)
      }) 
      .catch(error => {
          this.$noty.error(error.request.response)
      })
    },
    updateCampaignData: function (campaignData) {
      var url = 'campaign/campaigns-data/'
      putData(url,campaignData.pk,campaignData).then(res=> {
          console.log(res)
      }) 
      .catch(error => {
          this.$noty.error(error.request.response)
      })
    },
    deleteCampaign: function (campaign_id) {
      var url = 'campaign/campaigns/'
      putData(url,campaign_id).then(res=> {
          console.log(res)
      }) 
      .catch(error => {
          this.$noty.error(error.request.response)
      })
    },
    // Falta borrar campaing data de la base de los mapas
    deleteCampaignData: function (campaign_data_id) {
      var url = 'campaign/campaigns/'
      putData(url,campaign_data_id).then(res=> {
          console.log(res)
      }) 
      .catch(error => {
          this.$noty.error(error.request.response)
      })
    }

  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table th {
    border: 1px !important;
}
.modal-dialog{
  min-width: 90%;
}
.modal-header{
  border-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/configCampaigns.vue